/**
 * Net Oxygen special mapping for ISO639 codes.
 * It handles all the standard codes with some additions and
 * modifications.
 *
 * @see https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
 */

/**
 * @param string: The code to get the language name
 *
 * @return An object with the code corresponding language name
 *         in German, English and French.
 */
module.exports.get_languages_for_code = function (code) {
  if (all[code]) return all[code];
  return null;
};

/**
 * Return full list of ISO 639 codes
 *
 * @return An object with code as key, translated in
 *    German, English and French.
 */
module.exports.get_all = function () {
  return all;
};

/**
 * Return NO2 standard list of ISO 639 codes
 *
 * @return An object with code as key, translated in
 *    German, English and French.
 */
module.exports.get_standard = function () {
  return standard;
};

/**
 * Return NO2 extra list of ISO 639 codes
 *
 * @return An object with code as key, translated in
 *    German, English and French.
 */
module.exports.get_extra = function () {
  return extra;
};
const standard = {
  "aa": {
    "de": "Afar",
    "en": "Afar",
    "fr": "Afar"
  },
  "ab": {
    "de": "Abchasisch",
    "en": "Abkhazian",
    "fr": "Abkhaze"
  },
  "af": {
    "de": "Afrikaans",
    "en": "Afrikaans",
    "fr": "Afrikaans"
  },
  "am": {
    "de": "Amharisch",
    "en": "Amharic",
    "fr": "Amharique"
  },
  "ar": {
    "de": "Arabisch",
    "en": "Arabic",
    "fr": "Arabe"
  },
  "as": {
    "de": "Assamesisch",
    "en": "Assamese",
    "fr": "Assamais"
  },
  "ay": {
    "de": "Aymara",
    "en": "Aymara",
    "fr": "Aymara"
  },
  "az": {
    "de": "Aserbaidschanisch",
    "en": "Azerbaijani",
    "fr": "Azéri"
  },
  "ba": {
    "de": "Baschkirisch",
    "en": "Bashkir",
    "fr": "Bachkir"
  },
  "be": {
    "de": "Belorussisch",
    "en": "Belarussian",
    "fr": "Biélorusse"
  },
  "ber": {
    "de": "Berber",
    "en": "Berber",
    "fr": "Berbère"
  },
  "bg": {
    "de": "Bulgarisch",
    "en": "Bulgarian",
    "fr": "Bulgare"
  },
  "bh": {
    "de": "Biharisch",
    "en": "Bihari",
    "fr": "Bihari"
  },
  "bi": {
    "de": "Bislamisch",
    "en": "Bislama",
    "fr": "Bêche-de-mer"
  },
  "bm": {
    "de": "Bambara",
    "en": "Bambara",
    "fr": "Bambara"
  },
  "bn": {
    "de": "Bengalisch",
    "en": "Bengali",
    "fr": "Bengali"
  },
  "bo": {
    "de": "Tibetisch",
    "en": "Tibetan",
    "fr": "Tibétain"
  },
  "br": {
    "de": "Bretonisch",
    "en": "Breton",
    "fr": "Breton"
  },
  "bs": {
    "de": "Bosnisch",
    "en": "Bosnian",
    "fr": "Bosnien"
  },
  "ca": {
    "de": "Katalanisch",
    "en": "Catalan",
    "fr": "Catalan"
  },
  "ce": {
    "de": "Tschetschenisch",
    "en": "Chechen",
    "fr": "Tchétchène"
  },
  "gsw": {
    "de": "Schweizerdeutsch",
    "en": "Swiss-german",
    "fr": "Suisse allemand"
  },
  // Eventival
  "co": {
    "de": "Korsisch",
    "en": "Corsican",
    "fr": "Corse"
  },
  "crp": {
    "de": "Creole",
    "en": "Creole",
    "fr": "Créole"
  },
  "cs": {
    "de": "Tschechisch",
    "en": "Czech",
    "fr": "Tchèque"
  },
  "cy": {
    "de": "Walisisch",
    "en": "Welsh",
    "fr": "Gallois"
  },
  "da": {
    "de": "Dänisch",
    "en": "Danish",
    "fr": "Danois"
  },
  "de": {
    "de": "Deutsch",
    "en": "German",
    "fr": "Allemand"
  },
  "dyu": {
    "de": "Dyula",
    "en": "Dyula",
    "fr": "Dioula"
  },
  "dz": {
    "de": "Dzongkha",
    "en": "Dzongkha",
    "fr": "Boutani"
  },
  "el": {
    "de": "Griechisch",
    "en": "Greek",
    "fr": "Grec"
  },
  "en": {
    "de": "Englisch",
    "en": "English",
    "fr": "Anglais"
  },
  "eo": {
    "de": "Esperanto",
    "en": "Esperanto",
    "fr": "Espéranto"
  },
  "es": {
    "de": "Spanisch",
    "en": "Spanish",
    "fr": "Espagnol"
  },
  "et": {
    "de": "Estnisch",
    "en": "Estonian",
    "fr": "Estonien"
  },
  "eu": {
    "de": "Baskisch",
    "en": "Basque",
    "fr": "Basque"
  },
  "fa": {
    "de": "Farsi",
    "en": "Farsi",
    "fr": "Farsi"
  },
  "ff": {
    "de": "Fula",
    "en": "Fulah",
    "fr": "Peul"
  },
  "fi": {
    "de": "Finnisch",
    "en": "Finnish",
    "fr": "Finnois"
  },
  "fj": {
    "de": "Fiji",
    "en": "Fiji",
    "fr": "Fidjien"
  },
  "fo": {
    "de": "Färöisch",
    "en": "Faroese",
    "fr": "Féroïen"
  },
  "fr": {
    "de": "Französisch",
    "en": "French",
    "fr": "Français"
  },
  "fy": {
    "de": "Friesisch",
    "en": "Frisian",
    "fr": "Frison"
  },
  "ga": {
    "de": "Irisch",
    "en": "Irish",
    "fr": "Gaélique irlandais"
  },
  "gd": {
    "de": "Schottisches Gälisch",
    "en": "Gaelic (Scots)",
    "fr": "Gaélique écossais"
  },
  "gl": {
    "de": "Galizisch",
    "en": "Gallegan",
    "fr": "Galicien"
  },
  "gn": {
    "de": "Guarani",
    "en": "Guarani",
    "fr": "Guarani"
  },
  "gu": {
    "de": "Gujaratisch",
    "en": "Gujarati",
    "fr": "Goudjarati"
  },
  "ha": {
    "de": "Haussa",
    "en": "Hausa",
    "fr": "Haoussa"
  },
  "he": {
    "de": "Hebräisch",
    "en": "Hebrew",
    "fr": "Hébreu"
  },
  "hi": {
    "de": "Hindi",
    "en": "Hindi",
    "fr": "Hindi"
  },
  "hmn": {
    "de": "Hmong",
    "en": "Hmong",
    "fr": "Hmong"
  },
  "hr": {
    "de": "Kroatisch",
    "en": "Croatian",
    "fr": "Croate"
  },
  "hu": {
    "de": "Ungarisch",
    "en": "Hungarian",
    "fr": "Hongrois"
  },
  "hy": {
    "de": "Armenisch",
    "en": "Armenian",
    "fr": "Arménien"
  },
  "id": {
    "de": "Indonesisch",
    "en": "Indonesian",
    "fr": "Indonésien"
  },
  "ik": {
    "de": "Inupiak",
    "en": "Inupiaq",
    "fr": "Inupiak"
  },
  "is": {
    "de": "Isländisch",
    "en": "Icelandic",
    "fr": "Islandais"
  },
  "it": {
    "de": "Italienisch",
    "en": "Italian",
    "fr": "Italien"
  },
  "iu": {
    "de": "Inuktitut",
    "en": "Inuktitut",
    "fr": "Inuktitut"
  },
  "ja": {
    "de": "Japanisch",
    "en": "Japanese",
    "fr": "Japonais"
  },
  "jiv": {
    "de": "Shuar",
    "en": "Shuar",
    "fr": "Shuar"
  },
  "jv": {
    "de": "Javanesisch",
    "en": "Javanese",
    "fr": "Javanai"
  },
  "ka": {
    "de": "Georgisch",
    "en": "Georgian",
    "fr": "Géorgien"
  },
  "kab": {
    "de": "Kabyle",
    "en": "Kabyle",
    "fr": "Kabyle"
  },
  "kk": {
    "de": "Kasachisch",
    "en": "Kazakh",
    "fr": "Kazakh"
  },
  "kl": {
    "de": "Kalaallisut",
    "en": "Kalaallisut",
    "fr": "Groenlandais"
  },
  "km": {
    "de": "Kambodschanisch",
    "en": "Khmer",
    "fr": "Cambodgien"
  },
  "kn": {
    "de": "Kannada",
    "en": "Kannada",
    "fr": "Kannada"
  },
  "ko": {
    "de": "Koreanisch",
    "en": "Korean",
    "fr": "Coréen"
  },
  "ks": {
    "de": "Kaschmirisch",
    "en": "Kashmiri",
    "fr": "Cachemiri"
  },
  "ku": {
    "de": "Kurdisch",
    "en": "Kurdish",
    "fr": "Kurde"
  },
  "ky": {
    "de": "Kirgisisch",
    "en": "Kirghiz",
    "fr": "Kirghiz"
  },
  "la": {
    "de": "Lateinisch",
    "en": "Latin",
    "fr": "Latin"
  },
  "lb": {
    "de": "Luxemburgisch",
    "en": "Letzeburgesch",
    "fr": "Luxembougeois"
  },
  "ln": {
    "de": "Lingala",
    "en": "Lingala",
    "fr": "Lingala"
  },
  "lo": {
    "de": "Laotisch",
    "en": "Lao",
    "fr": "Lao"
  },
  "lt": {
    "de": "Litauisch",
    "en": "Lithuanian",
    "fr": "Lithuanien"
  },
  "lv": {
    "de": "Lettisch",
    "en": "Latvian",
    "fr": "Letton"
  },
  "mg": {
    "de": "Malagasisch",
    "en": "Malagasy",
    "fr": "Malgache"
  },
  "mi": {
    "de": "Maorisch",
    "en": "Maori",
    "fr": "Maori"
  },
  "mk": {
    "de": "Mazedonisch",
    "en": "Macedonian",
    "fr": "Macédonien"
  },
  "ml": {
    "de": "Malajalam",
    "en": "Malayalam",
    "fr": "Malayalam"
  },
  "mn": {
    "de": "Mongolisch",
    "en": "Mongolian",
    "fr": "Mongol"
  },
  "mo": {
    "de": "Moldavisch",
    "en": "Moldavian",
    "fr": "Moldave"
  },
  "mos": {
    "de": "Mossi",
    "en": "Mossi",
    "fr": "Moré"
  },
  "mr": {
    "de": "Marathi",
    "en": "Marathi",
    "fr": "Marathe"
  },
  "ms": {
    "de": "Malaysisch",
    "en": "Malay",
    "fr": "Malais"
  },
  "mt": {
    "de": "Maltesisch",
    "en": "Maltese",
    "fr": "Maltais"
  },
  "my": {
    "de": "Burmesisch",
    "en": "Burmese",
    "fr": "Birman"
  },
  "na": {
    "de": "Nauruisch",
    "en": "Nauru",
    "fr": "Nauri"
  },
  "ne": {
    "de": "Nepalesisch",
    "en": "Nepali",
    "fr": "Népalais"
  },
  "nl": {
    "de": "Holländisch",
    "en": "Dutch",
    "fr": "Néerlandais"
  },
  "no": {
    "de": "Norwegisch",
    "en": "Norwegian",
    "fr": "Norvégien"
  },
  "nso": {
    "de": "Pedi",
    "en": "Pedi",
    "fr": "Pedi"
  },
  "oc": {
    "de": "Okzitanisch",
    "en": "Occitan",
    "fr": "Occitan"
  },
  "om": {
    "de": "Oromo",
    "en": "Oromo",
    "fr": "Oromo"
  },
  "or": {
    "de": "Oriya",
    "en": "Oriya",
    "fr": "Oriya"
  },
  "pa": {
    "de": "Pundjabisch",
    "en": "Panjabi",
    "fr": "Pendjabi"
  },
  "phi": {
    "de": "Philippinen",
    "en": "Philippine",
    "fr": "Philippin"
  },
  "pl": {
    "de": "Polnisch",
    "en": "Polish",
    "fr": "Polonais"
  },
  "ps": {
    "de": "Paschtu",
    "en": "Pushto",
    "fr": "Pachto"
  },
  "pt": {
    "de": "Portugiesisch",
    "en": "Portuguese",
    "fr": "Portugais"
  },
  "qu": {
    "de": "Quechua",
    "en": "Quechua",
    "fr": "Quechua"
  },
  "rm": {
    "de": "Rätoromanisch",
    "en": "Rhaeto-Romance",
    "fr": "Rhéto-roman"
  },
  "rn": {
    "de": "Kirundisch",
    "en": "Rundi",
    "fr": "Roundi"
  },
  "ro": {
    "de": "Rumänisch",
    "en": "Romanian",
    "fr": "Roumain"
  },
  "rom": {
    "de": "Roma",
    "en": "Romany",
    "fr": "Tsigane"
  },
  "ru": {
    "de": "Russisch",
    "en": "Russian",
    "fr": "Russe"
  },
  "rw": {
    "de": "Kinyarwanda",
    "en": "Kinyarwanda",
    "fr": "Rouanda"
  },
  "sa": {
    "de": "Sanskrit",
    "en": "Sanskrit",
    "fr": "Sanscrit"
  },
  "sd": {
    "de": "Zinti",
    "en": "Sindhi",
    "fr": "Sindhi"
  },
  "se": {
    "de": "Sami",
    "en": "Sami",
    "fr": "Sami"
  },
  "sg": {
    "de": "Sango",
    "en": "Sango",
    "fr": "Sango"
  },
  "sh": {
    "de": "Serbo-Kroatisch",
    "en": "-Croat",
    "fr": "Serbo-croate"
  },
  "si": {
    "de": "Singhalesisch",
    "en": "Sinhalese",
    "fr": "Cingalais"
  },
  "sk": {
    "de": "Slowakisch",
    "en": "Slovak",
    "fr": "Slovaque"
  },
  "sl": {
    "de": "Slowenisch",
    "en": "Slovenian",
    "fr": "Slovène"
  },
  "sm": {
    "de": "Samoanisch",
    "en": "Samoan",
    "fr": "Samoan"
  },
  "sn": {
    "de": "Schonisch",
    "en": "Shona",
    "fr": "Chona"
  },
  "so": {
    "de": "Somalisch",
    "en": "Somali",
    "fr": "Somali"
  },
  "sq": {
    "de": "Albanisch",
    "en": "Albanian",
    "fr": "Albanais"
  },
  "sr": {
    "de": "Serbisch",
    "en": "Serbian",
    "fr": "Serbe"
  },
  "ss": {
    "de": "Swasiländisch",
    "en": "Swati",
    "fr": "Siswati"
  },
  "st": {
    "de": "Sesothisch",
    "en": "Sesotho",
    "fr": "Sesotho"
  },
  "su": {
    "de": "Sudanesisch",
    "en": "Sundanese",
    "fr": "Soundanais"
  },
  "sv": {
    "de": "Schwedisch",
    "en": "Swedish",
    "fr": "Suédois"
  },
  "sw": {
    "de": "Suaheli",
    "en": "Swahili",
    "fr": "Souahéli"
  },
  "ta": {
    "de": "Tamilisch",
    "en": "Tamil",
    "fr": "Tamoul"
  },
  "te": {
    "de": "Tegulu",
    "en": "Telugu",
    "fr": "Télougou"
  },
  "tg": {
    "de": "Tadschikisch",
    "en": "Tajik",
    "fr": "Tadjik"
  },
  "th": {
    "de": "Thai",
    "en": "Thai",
    "fr": "Thaï"
  },
  "tk": {
    "de": "Turkmenisch",
    "en": "Turkmen",
    "fr": "Turkmène"
  },
  "tl": {
    "de": "Tagalog",
    "en": "Tagalog",
    "fr": "Tagal"
  },
  "tmh": {
    "de": "Tamaschek",
    "en": "Tamashek",
    "fr": "Tamacheq"
  },
  "tn": {
    "de": "Sezuan",
    "en": "Tswana",
    "fr": "Setchwana"
  },
  "tr": {
    "de": "Türkisch",
    "en": "Turkish",
    "fr": "Turc"
  },
  "ts": {
    "de": "Tsongaisch",
    "en": "Tsonga",
    "fr": "Tsonga"
  },
  "tt": {
    "de": "Tatarisch",
    "en": "Tatar",
    "fr": "Tatar"
  },
  "tvl": {
    "de": "Tuvalesisch",
    "en": "Tuvaluan",
    "fr": "Tuvaluan"
  },
  "tw": {
    "de": "Twi",
    "en": "Twi",
    "fr": "Tchi"
  },
  "ug": {
    "de": "Uigur",
    "en": "Uighur",
    "fr": "Ouïgour"
  },
  "uk": {
    "de": "Ukrainisch",
    "en": "Ukrainian",
    "fr": "Ukrainien"
  },
  "ur": {
    "de": "Urdu",
    "en": "Urdu",
    "fr": "Ourdou"
  },
  "uz": {
    "de": "Usbekisch",
    "en": "Uzbek",
    "fr": "Ouzbek"
  },
  "vi": {
    "de": "Vietnamesisch",
    "en": "Vietnamese",
    "fr": "Vietnamien"
  },
  "vo": {
    "de": "Volapük",
    "en": "Volapük",
    "fr": "Volapük"
  },
  "wo": {
    "de": "Wolof",
    "en": "Wolof",
    "fr": "Ouolof"
  },
  "xh": {
    "de": "Xhosa",
    "en": "Xhosa",
    "fr": "Xhosa"
  },
  "yi": {
    "de": "Jiddish",
    "en": "Yiddish",
    "fr": "Yidich"
  },
  "za": {
    "de": "Zhuang",
    "en": "Zhuang",
    "fr": "Tchouang"
  },
  "zh": {
    "de": "Chinesisch",
    "en": "Chinese",
    "fr": "Chinois"
  },
  "zu": {
    "de": "Zulu",
    "en": "Zulu",
    "fr": "Zoulou"
  }
};
const extra = {
  "no_lang": {
    "de": "ohne Dialog",
    "en": "no dialogue",
    "fr": "sans dialogue"
  },
  // Eventival
  "cmn": {
    "de": "Mandarin",
    "en": "Mandarin Chinese",
    "fr": "Mandarin"
  },
  // Eventival
  "zq": {
    "de": "Deutsch/Englisch",
    "en": "German/English",
    "fr": "Allemand/Anglais"
  },
  "zr": {
    "de": "Deutsch/Französisch/Englisch",
    "en": "German/French/English",
    "fr": "Allemand/Français/Anglais"
  },
  "zv": {
    "de": "Deutsch/Italienisch",
    "en": "German/Italian",
    "fr": "Allemand/Italien"
  },
  "zw": {
    "de": "Französisch/Englisch",
    "en": "French/English",
    "fr": "Français/Anglais"
  },
  "zx": {
    "de": "Französisch/Italienisch",
    "en": "French/Italian",
    "fr": "Français/Italien"
  },
  "zy": {
    "de": "Deutsch/Französisch",
    "en": "German/French",
    "fr": "Allemand/Français"
  },
  "no_sub": {
    "de": "keine Untertitel",
    "en": "no subtitles",
    "fr": "sans sous-titres"
  } // Eventival
};
const all = Object.assign({}, standard, extra);